import { ContactRequest } from "models/contact-request.model";
const config = useRuntimeConfig();
export interface ContactRequestData {
  fullName: string;
  promocode?: string;
  email: string;
  phoneNumber: string;
  requestText: string;
}

export const contactRequest = {
  useGetAllContactsRequests: createUseApi<void, ContactRequest[]>({
    url: `${config.public.url}/contact-request`,
    method: "GET",
    requireAuthentication: true,
  }),
  useContactRequests: createUseApi<
    {
      page: number;
      limit: number;
      sortData: {
        sortField: string;
        sortOrder: string;
      };
      dateRange: Date[];
      status: string | undefined;
      userEmail: string;
    } | void,
    {
      data: ContactRequest[];
      meta: {
        total: number;
      };
    }
  >({
    // http://localhost:7702/contact-request/filter?page=1&limit=2&orderBy=createdAt&order=DESC
    url: `${config.public.url}/contact-request/filter`,
    method: "GET",
    queryBuilder: (input) => {
      if (!input) return { page: 0, limit: 10 };
      else {
        return {
          page: input.page,
          limit: input.limit,
          orderBy: input?.sortData.sortField,
          order: input?.sortData.sortOrder,
          createdAtFrom: input?.dateRange[0].toISOString(),
          createdAtTo: input?.dateRange[1].toISOString(),
          status: input?.status,
          userEmail: input?.userEmail,
        };
      }
    },
    requireAuthentication: true,
  }),
  useReject: createUseApi<string, void>({
    url: (input) => `${config.public.url}/contact-request/${input}/reject`,
    method: "POST",
    requireAuthentication: true,
  }),
  useApprove: createUseApi<string, void>({
    url: (input) => `${config.public.url}/contact-request/${input}/approve`,
    method: "POST",
    requireAuthentication: true,
  }),
  useSendContactRequest: createUseApi<ContactRequestData, void>({
    method: "POST",
    url: `${config.public.url}/contact-request`,
    dataBuilder: (contactData) => ({
      dataFields: [
        {
          title: "Full name",
          value: contactData.fullName,
        },
        {
          title: "E-mail",
          value: contactData.email,
        },
        {
          title: "Phone number",
          value: contactData.phoneNumber,
        },
        {
          title: "Request text",
          value: contactData.requestText,
        },
        {
          title: "Promocode",
          value: contactData.promocode ?? "No promocode",
        },
      ],
    }),
    requireAuthentication: false,
  }),
};
